var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"bg1"}),_c('section',{attrs:{"id":"banner-section"}},[_c('Banner')],1),_c('section',{attrs:{"id":"down"}},[_c('Dates')],1),_c('section',{attrs:{"id":"bottom"}},[_c('BottomCTA')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }